<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { t } from '@/utils/utils';
import { LegendItem } from '@/models/LegendItem.model';

/**
 *
 * @version 1.0.0
 * @since
 */
export default defineComponent({
	name: 'MapLegend',
	props: {
		list: {
			required: true,
			type: Array as PropType<LegendItem[]>,
		},
		unit: {
			required: false,
			type: String,
			default: () => '',
		},
		toMarkUnused: {
			required: false,
			type: Boolean,
			default: () => false,
		},
	},
	computed: {
		/**
		 * Filters item if both min and max are not numbers.
		 */
		displayList(): LegendItem[] {
			return (this.list as LegendItem[]).filter(
				({ min, max }) => !(!Number.isFinite(min) && !Number.isFinite(max))
			);
		},
	},
	methods: {
		formatMinMax(min: number, max: number): string {
			if (!Number.isFinite(min) && Number.isFinite(max)) {
				return `< ${max}`;
			}
			if (!Number.isFinite(max) && Number.isFinite(min)) {
				return `> ${min}`;
			}

			return `${min} ${t('word.to')} ${max}`;
		},
		isUnused(item: LegendItem): boolean {
			return this.toMarkUnused && !item.usage;
		},
	},
});
</script>

<template>
	<div class="map-legend">
		<h4
			v-if="unit"
			class="map-legend__title m-0 mb-8"
		>
			{{ $t(`unit.${unit}`) }}
		</h4>
		<div
			v-for="item in displayList"
			:key="JSON.stringify(item)"
			v-tooltip.left="isUnused(item) ? $t('message.unusedLegendItem') : ''"
			:class="['width-100', 'map-legend-item', { 'map-legend-item--unused': isUnused(item) }]"
		>
			<div>
				<span
					class="map-legend-item__color mr-8"
					:style="{ background: item.color }"
				/>
			</div>
			<span class="map-legend-item__text"> {{ formatMinMax(item.min, item.max) }} </span>
		</div>
	</div>
</template>

<style scoped lang="scss">
.map-legend {
	display: flex;
	flex-direction: column;
	padding: 16px;
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
  border: 1px solid #0000002e;
	border-radius: 6px;
  background: white;

	> *:not(:last-child) {
		margin-bottom: 4px;
	}
}

.map-legend__title {
  @include tools.font-size(14px, 17px);
	font-weight: 500;
}

.map-legend-item {
	display: flex;
	align-items: center;
}

.map-legend-item--unused {
	opacity: 0.4;
}

.map-legend-item__color {
	display: inline-block;
	width: 11px;
	height: 11px;
	border-radius: 50%;

	&:hover {
		border: 1px solid tokens.$color-gray-13;
	}
}

.map-legend-item__text {
  @include tools.font-size(12px, 18px);
}
</style>
